//import react polyfill
import 'babel-polyfill';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import React from 'react'
import { render } from 'react-dom'

//Import App Components
import './index.css'
import App from './App';
import './services/Interceptor'
// import registerServiceWorker from './registerServiceWorker'

// Import ant less file and override variables
import "./assets/less/ant.css"

//Import styles
import './assets/styles/main.css'

//React Redux and Router 
import { createStore, applyMiddleware, compose } from 'redux'
import { IntlProvider } from 'react-intl-redux'
import { addLocaleData } from 'react-intl'
import { Provider } from 'react-redux'
import { routerMiddleware, ConnectedRouter } from 'react-router-redux'
import thunk from 'redux-thunk'
import history from './services/History'
import rootReducer from './reducers/rootReducer'

//Initial state
import { initialState } from './constants/InitialState'
import enLocaleData from 'react-intl/locale-data/en'
import faLocaleData from 'react-intl/locale-data/fa'

// Intl polyfill for old browsers
import areIntlLocalesSupported from 'intl-locales-supported'
var localesMyAppSupports = [
  /* list locales here */
];
if (global.Intl) {
  // Determine if the built-in `Intl` has the locale data we need.
  if (!areIntlLocalesSupported(localesMyAppSupports)) {
    // `Intl` exists, but it doesn't have the data we need, so load the
    // polyfill and patch the constructors we need with the polyfill's.
    var IntlPolyfill = require('intl');
    Intl.NumberFormat = IntlPolyfill.NumberFormat;
    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
  }
} else {
  // No `Intl`, so use and load the polyfill.
  global.Intl = require('intl');
}

addLocaleData([...enLocaleData, ...faLocaleData])

const middleware = [
  thunk,
  routerMiddleware(history)
];

const composeEnhancer = (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
const composedEnhancers = composeEnhancer(
  applyMiddleware(...middleware),
);

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
);

store.subscribe(() => {
  localStorage.setItem('saved_store_state', JSON.stringify(store.getState()));
});

export default store;

const target = document.querySelector('#root');

render(<Provider store={store}>
  <IntlProvider>
    <ConnectedRouter history={history}>
      <div>
        <App />
      </div>
    </ConnectedRouter>
  </IntlProvider>
</Provider>,
  target
);

// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js